/**
 * PO Number field formatter
 */

import {useTextField} from '@hconnect/tuc-processes/fields/textField/useTextField'
import {useChangeableField} from '@hconnect/tuc-processes/orderManagement/orderChange'

import type {FieldFormatter} from './types'
import {createValueArray} from './utils'

export const usePoNumberFormatter = (): FieldFormatter => {
  const {fieldValue: poNumber, defaultFieldValue: defaultPoNumber} = useTextField('poNumber')
  const poNumberState = useChangeableField('poNumber')

  return (context) => {
    const {t} = context
    const requiresApproval = poNumberState.state === 'requireDispatchConfirmation'
    const hasChanges = poNumberState.isDirty
    const oldValue = defaultPoNumber || null
    const newValue = poNumber || null

    const values = createValueArray(
      oldValue,
      newValue,
      hasChanges,
      t('orderIntake.rmc.orderManagement.notSpecified', 'Not specified')
    )

    return {values, requiresApproval, hasChanges}
  }
}
